// extracted by mini-css-extract-plugin
export default {"devicetextdata":"textdata_devicetextdata__7IWOL","texttable":"textdata_texttable__Ex-8x"};